import { sortBy } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  roles: {}
}

export const getters = {
  roles: state => state.roles.list
}

export const mutations = {
  setRoles (state, roles) {
    state.roles = roles
    state.roles.list = sortBy(roles.list, ['level'])
  }
}

export const actions = {
  async getRoles (context) {
    let error, response
    [error, response] = await to(api.getRoles(context.rootGetters.application))
    if (error || !response) return Promise.reject(error)

    context.commit('setRoles', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
